import React, { useState } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function FlipBoxRender({ node }) {
  const content = node.content || {};
  
  // Front
  const frontTitle = content.frontTitle || 'O2 Mobile M';
  const frontIcon = content.frontIcon || '🚀';
  const frontBg = content.frontBg || '#00A9E0';
  
  // Back
  const backTitle = content.backTitle || 'Unglaubliche 25GB';
  const backDesc = content.backDesc || 'Endlos surfen im besten 5G Netz. Ab sofort mit Grow-Vorteil ausgestattet und jedes Jahr mehr Volumen erhalten.';
  const backButton = content.backButton || 'Mehr Erfahren';
  const backBg = content.backBg || '#001a2c';

  const minHeight = content.minHeight || '300px';

  const [isFlipped, setIsFlipped] = useState(false);

  // Helper für die Perspektive und Transition.
  // Das div braucht perspective, das innere Wrapper transform-style, die Seiten backface-visibility
  return (
    <div 
      style={{
        width: '100%',
        height: minHeight,
        perspective: '1000px',
        cursor: 'pointer'
      }}
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
    >
      <div style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        transformStyle: 'preserve-3d',
        transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
      }}>
        
        {/* FRONT */}
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backfaceVisibility: 'hidden',
          background: frontBg,
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          color: '#fff',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>{frontIcon}</div>
          <h3 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>{frontTitle}</h3>
        </div>

        {/* BACK */}
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backfaceVisibility: 'hidden',
          background: backBg,
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          color: '#fff',
          textAlign: 'center',
          transform: 'rotateY(180deg)', // Rücken-Karte umgedreht
          boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}>
          <h3 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0 0 16px 0', color: 'var(--tef-primary, #00A9E0)' }}>
            {backTitle}
          </h3>
          <p style={{ fontSize: '15px', color: '#cbd5e1', lineHeight: '1.5', margin: '0 0 24px 0' }}>
            {backDesc}
          </p>
          <button style={{
            padding: '10px 24px',
            background: 'var(--tef-primary, #00A9E0)',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontWeight: '600',
            cursor: 'pointer'
          }}>
            {backButton}
          </button>
        </div>

      </div>
    </div>
  );
}

registry.register('FlipBox', {
  label: 'Hover 3D Flip Karte',
  icon: '🎴', 
  category: 'advanced', // oder premium
  component: FlipBoxRender,
  
  defaultProps: {
    content: {
      frontTitle: 'O2 Mobile M',
      frontIcon: '🔥',
      frontBg: 'linear-gradient(135deg, #00A9E0, #0077b6)',
      backTitle: 'Highspeed Deal',
      backDesc: 'Jetzt im exklusiven Tarif-Bundle. 25GB Volumen für alle Deine Devices.',
      backButton: 'Zum Deal',
      backBg: '#0f172a', /* slate-900 */
      minHeight: '300px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Vorderseite (Front)',
          fields: [
            { name: 'content.frontTitle', label: 'Titel', type: 'text' },
            { name: 'content.frontIcon', label: 'Icon (Emoji)', type: 'text' },
            { name: 'content.frontBg', label: 'Hintergrund (CSS / Farbe)', type: 'text' }
          ]
        },
        {
          title: 'Rückseite (Back)',
          fields: [
            { name: 'content.backTitle', label: 'Titel', type: 'text' },
            { name: 'content.backDesc', label: 'Beschreibung', type: 'textarea' },
            { name: 'content.backButton', label: 'Button-Label', type: 'text' },
            { name: 'content.backBg', label: 'Hintergrund (CSS / Farbe)', type: 'text' }
          ]
        },
        {
          title: 'Abmessungen',
          fields: [
            { name: 'content.minHeight', label: 'Mindesthöhe der Karte', type: 'text' }
          ]
        }
      ]
    }
  ]
});
